<template>
  <CRow>
    <CModal
        :title="
        submitType === 'Update'
          ? $lang.price.crud.edit
          : $lang.price.crud.create
      "
        size="lg"
        :show.sync="largeModal"
        :no-close-on-backdrop="true"
        color="primary"
    >
      <CAlert color="danger" closeButton :show.sync="dismissCountDown" fade>{{
          err_msg
        }}
      </CAlert>

      <CForm novalidate @submit.prevent="onSubmit">
        <CCardBody>

          <div
              class="form-group"
              :class="{ 'form-group--error': $v.price.title.$error }"
          >
            <label class="form__label"
            >{{ $lang.price.form.title }}
              <required_span/>
            </label>
            <input
                :placeholder="$lang.price.form.title"
                class="form-control"
                :maxlength="maxlength.title"
                v-model="price.title"
            />
            <small
                class="error"
                v-if="
                $v.price.title.$error && !$v.price.title.required
              "
            >{{ $lang.price.validation.required.title }}</small
            >
            <small
                class="error"
                v-if="
                $v.price.title.$error && !$v.price.title.minLength
              "
            >{{ $lang.price.validation.minLength.title }}
              {{ $v.price.title.$params.minLength.min }}
              {{ $lang.price.validation.common.letter }}</small
            >
          </div>


          <div
              class="form-group"
              :class="{ 'form-group--error': $v.price.from.$error }"
          >
            <label class="form__label"
            >{{ $lang.price.form.from }}
              <required_span/>
            </label>
            <input
                :placeholder="$lang.price.form.from"
                class="form-control"
                :maxlength="maxlength.from"
                v-model="price.from"
            />
            <small
                class="error"
                v-if="
                $v.price.from.$error && !$v.price.from.required
              "
            >{{ $lang.price.validation.required.from }}</small
            >
            <small
                class="error"
                v-if="
                $v.price.from.$error && !$v.price.from.minLength
              "
            >{{ $lang.price.validation.minLength.from }}
              {{ $v.price.from.$params.minLength.min }} </small
            >
          </div>

          <div
              class="form-group"
              :class="{ 'form-group--error': $v.price.to.$error }"
          >
            <label class="form__label"
            >{{ $lang.price.form.to }}
              <required_span/>
            </label>
            <input
                :placeholder="$lang.price.form.to"
                class="form-control"
                :maxlength="maxlength.to"
                v-model="price.to"
            />
            <small
                class="error"
                v-if="
                $v.price.to.$error && !$v.price.to.required
              "
            >{{ $lang.price.validation.required.to }}</small
            >
            <small
                class="error"
                v-if="
                $v.price.to.$error && !$v.price.to.minLength
              "
            >{{ $lang.price.validation.minLength.title }}
              {{ $v.price.title.$params.minLength.min }}</small
            >
          </div>
          <div class="form-group" :class="{ 'form-group--error': '' }">
            <label class="form__label"
            >{{ $lang.price.form.isActive }}
            </label>
            <input
                type="checkbox"
                :placeholder="$lang.price.form.isActive"
                :value="1"
                @change="changedIsActive"
                v-model="price.isActive"
            />
          </div>
        </CCardBody>
        <CCardFooter>
          <CButton
              type="submit"
              :disabled="submitted"
              size="sm"
              color="primary"
          >
            <CIcon name="cil-check-circle"/>
            {{ $lang.buttons.general.crud.submit }}
          </CButton>
          &nbsp;
        </CCardFooter>
      </CForm>
      <template #footer style="display: none">
        <CButton @click="darkModal = false" color="danger" style="display: none"
        >Discard
        </CButton
        >
        <CButton
            @click="darkModal = false"
            color="success"
            style="display: none"
        >Accept
        </CButton
        >
      </template>
    </CModal>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <div class="row">
            <CCol sm="6" class="align-self-center">
              <strong>{{ $lang.price.title }}</strong>
            </CCol>
            <CCol sm="6" class="align-self-center">
              <div class="text-sm-right mt-3 mt-sm-0">
                <CButton
                    color="primary"
                    v-on:click="createTableRow"
                    v-if="checkPermission('create-price')"
                    style="margin-right: 10px"
                >
                  {{ $lang.buttons.general.crud.create }}
                </CButton>
                <CButtonGroup class="file-export">
                  <CButton color="secondary" disabled>
                    {{ $lang.buttons.export.title }}
                  </CButton>
                  <CButton
                      color="danger"
                      v-c-tooltip="$lang.buttons.export.pdf"
                      v-on:click="exports(self, 'pdf', module, 'Price')"
                  >
                    <i class="fas fa-file-pdf"></i>
                  </CButton>
                  <VueJsonToCsv
                      class="btn btn-success"
                      v-c-tooltip="$lang.buttons.export.excel"
                      :json-data="json_data"
                      :labels="json_label"
                      :csv-title="json_title"
                  >
                    <i class="fas fa-file-excel"></i>
                  </VueJsonToCsv>
                </CButtonGroup>
              </div>
            </CCol>
          </div>
        </CCardHeader>
        <CCardBody>
          <CAlert
              :color="messageColor"
              closeButton
              :show.sync="dismissCountDownS"
              fade
          >{{ alertMessage }}
          </CAlert
          >
          <v-server-table
              :columns="columns"
              url="/price/list"
              :options="options"
              ref="myTable"
              @loaded="exports(self, 'Excel', module, 'Price')"
          >
            <template #status="data">
              <CBadge :color="statusBudget(data.row.status)">{{ data.row.status }}</CBadge>
            </template>
            <template #title="data">
              <span :title="data.row.title">{{
                  trimfunction(data.row.title, 20)
                }}</span>
            </template>
            <template #actions="data">
              <CButton
                  color="success"
                  v-c-tooltip="$lang.buttons.general.crud.edit"
                  v-on:click="editTableRow(data.row.id)"
                  v-if="checkPermission('edit-price')"
              >
                <i class="fas fa-pencil-alt"></i>
              </CButton>
              <CButton
                  color="danger"
                  v-c-tooltip="$lang.buttons.general.crud.delete"
                  v-on:click="deletePopup(data.row.id)"
                  v-if="checkPermission('delete-price')"
              >
                <i class="fas fa-trash"></i>
              </CButton>
            </template>
          </v-server-table>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import Vue from "vue";
import VueForm from "vue-form";
import {price} from "/src/store/url.js";
import {Mixin} from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import {ServerTable} from "vue-tables-2";
import VueSweetalert2 from "vue-sweetalert2";
import {minLength, required} from "vuelidate/lib/validators";
import required_span from "../../components/layouts/general/required-span";
import VueJsonToCsv from "vue-json-to-csv";
import {Maxlength} from "../../store/maxlength";

Vue.use(VueSweetalert2);
Vue.use(ServerTable, {}, false);
Vue.use(VueForm, options);

export default {
  name: "price",
  mixins: [Mixin],
  components: {
    required_span,
    VueJsonToCsv,
  },
  data() {
    return {
      submitted: false,
      json_data: [],
      json_label: {},
      json_title: "",
      isActiveFields: 1,
      err_msg: "",
      largeModal: false,
      submitType: "",
      alertMessage: "",
      messageColor: "success",
      showAlert: false,
      dismissCountDown: 0,
      dismissCountDownS: 0,
      self: this,
      msg: "",
      items: [],
      activePage: 1,
      module: price,
      price: {
        title: "",
        from: "",
        to: "",
      },
      columns: ["title", "from", 'to', 'status', "actions"],
      maxlength: {
        title: Maxlength.price.title,
        from: Maxlength.price.from,
        to: Maxlength.price.to,
      },
      data: [],
      options: {
        headings: {
          title: this.$lang.price.table.title,
          from: this.$lang.price.table.from,
          to: this.$lang.price.table.to,
          status: this.$lang.common.table.isActive,
          actions: this.$lang.common.general.actions,
        },
        editableColumns: ["title", "type"],
        sortable: ["title", "type"],
        filterable: ["title", "type"],
      },
    };
  },
  validations: {
    price: {
      title: {
        required,
        minLength: minLength(1),
      },
      from: {
        required,
        minLength: minLength(1),
      },
      to: {
        required,
        minLength: minLength(1),
      },
    },
  },
  mounted() {
    let self = this;
    self.dismissCountDown = 0;
    self.dismissCountDownS = 0;
    if (localStorage.getItem("showAlert") !== "") {
      this.setAlert(true);
    }
    this.setAlert(false);
    localStorage.setItem("showAlert", "");
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page);
        }
      },
    },
  },
  methods: {
    changedIsActive(e) {
      let self = this;
      this.v = e.target.checked;
      if (this.v) {
        self.price.isActive = 1;
      } else {
        self.price.isActive = 0;
      }
    },
    setAlert(value) {
      this.showAlert = value;
    },
    deletePopup(item) {
      this.$swal({
        title: this.$lang.common.delete_swal.are_you,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#e55353",
        confirmButtonText: this.$lang.common.delete_swal.yes_delete,
        cancelButtonText: this.$lang.common.delete_swal.cancel,
      }).then((result) => {
        // <--
        if (result.value) {
          // <-- if accepted
          let self = this;
          axios
              .delete(this.deleteUrlWeb(this.module, item), self)
              .then(function (response) {
                if (response.data.status === 200) {
                  self.$refs.myTable.refresh();
                  self.alertMessage = response.data.message;
                  self.messageColor = "success";
                  self.dismissCountDownS = 10;
                } else {
                  self.$refs.myTable.refresh();
                  self.alertMessage = response.data.message;
                  self.messageColor = "danger";
                  self.dismissCountDownS = 10;
                }
              }).catch(function (error) {
            let data;
            if (error.response.data.error) {
              data = error.response.data.error.toString();
            } else {
              data = error.response.data.message;
            }
            self.alertMessage = data;
            self.messageColor = "danger";
            self.dismissCountDown = 10;
            self.submitted = false;
          });
        }
      });
    },
    createTableRow() {
      let self = this;
      self.$v.$reset();
      self.submitType = "Create";
      self.price.title = "";
      self.price.from = "";
      self.price.to = "";
      self.price.isActive = 1;
      self.largeModal = true;
      //this.$router.push({name: 'Country Create'})
    },
    editTableRow(item) {
      let self = this;
      self.$v.$reset();
      self.submitType = "Update";
      let id = item;
      self.editId = item;
      axios
          .get(this.viewUrlApi(this.module, id), self.model)
          .then(function (response) {
            if (response) {
              let responseData = response.data.data;
              self.price.title = responseData.title;
              self.price.from = responseData.from;
              self.price.to = responseData.to;
              self.price.isActive = responseData.isActive;
            } else {
              self.data = [];
            }
          });

      // this.$router.push({path: `country/edit/${(item)}`})
      self.largeModal = true;
    },
    rowClicked(item) {
      this.$router.push({path: `price/view/${item}`});
    },
    pageChange(val) {
      this.$router.push({query: {page: val}});
    },
    loadData() {
      let self = this;
      axios
          .get(this.listUrlApi(this.module), self.model)
          .then(function (response) {
            if (response) {
              self.data = response.data;
            } else {
              self.data = [];
            }
          });
    },
    onSubmit() {
      let self = this;
      this.$v.price.$touch();
      if (this.$v.price.$invalid) {
        self.submitted = false; //Enable Button
        this.submitStatus = "ERROR";
      } else {
        self.submitted = true; //Disable Button
        this.submitStatus = "PENDING";

        if (this.submitType === "Update") {
          setTimeout(() => {
            let self = this;
            const postData = {
              title: self.price.title,
              from: self.price.from,
              to: self.price.to,
              isActive: self.price.isActive,
            };
            axios
                .post(this.updateUrlweb(this.module, self.editId), postData)
                .then(function (response) {
                  self.submitted = false; //Enable Button
                  if (response.data.code === 200) {
                    self.largeModal = false;
                    self.$refs.myTable.refresh();
                    self.alertMessage = response.data.message;
                    self.messageColor = "success";
                    self.dismissCountDownS = 10;
                  } else {
                    self.err_msg = response.data.message;
                    self.messageColor = "danger";
                    self.dismissCountDown = 10;
                  }
                })
                .catch(function (error) {
                  let data;
                  if (error.response.data.error) {
                    data = error.response.data.error.toString();
                  } else {
                    data = error.response.data.message;
                  }
                  self.err_msg = data;
                  self.dismissCountDown = 10;
                  self.submitted = false; //Enable Button
                });
          }, 500);
        } else {
          setTimeout(() => {
            let self = this;
            const postData = {
              title: self.price.title,
              from: self.price.from,
              to: self.price.to,
              isActive: self.price.isActive,
            };
            axios
                .post(this.createUrlWeb(this.module), postData)
                .then(function (response) {
                  if (response.data.code === 200) {
                    self.alertMessage = response.data.message;
                    self.messageColor = "success";
                    self.dismissCountDownS = 10;
                    self.submitted = false; //Enable Button
                    self.largeModal = false;
                    self.$refs.myTable.refresh();
                  } else {
                    self.err_msg = response.data.message;
                    self.messageColor = "danger";
                    self.dismissCountDown = 10;
                    self.submitted = false; //Enable Button
                  }
                })
                .catch(function (error) {
                  let data;
                  if (error.response.data.error) {
                    data = error.response.data.error.toString();
                  } else {
                    data = error.response.data.message;
                  }
                  self.err_msg = data;
                  self.dismissCountDown = 10;
                  self.submitted = false; //Enable Button
                });
          }, 500);
        }
      }
    },
  },
};
</script>
